import { useState } from "react";
import { RestItemContainer, RestListContainer } from "../data/Types";
import { useFetch } from "../hooks/data/useFetcher"
import { useOrganization } from "../hooks/entities/useOrganization"
import { keyboard } from "@testing-library/user-event/dist/keyboard";

export const useBilling = () => {
    const data = useBillingData();
    return {
        load: data.getBillingPlants,
        dataPlants: data.dataPlants,
        dataDetails: data.dataDetails,
        allBilling: data.allBilling,
        getBillingPlantsDetails: data.getBillingPlantsDetails
    }
}

export const useBillingData = () => {
    const org = useOrganization().currentOrganization;
    const api = useBillingApi();
    const [dataPlants, setDataPlants] = useState<BillingMonthPlants[]>([]);
    const [dataDetails, setDataDetails] = useState<string[]>([]);

    const [allBilling, setAllBilling] = useState<BillingType>();

    return {
        dataPlants: dataPlants,
        dataDetails: dataDetails,
        allBilling: allBilling,
        getBillingPlants: async () => {
            const data = await api.getBillingPlants(org?.id ?? "");
            setAllBilling(data);
            setDataPlants(data?.plants);
        },
        getBillingPlantsDetails: async (monthKey: number) => {
            const data = await api.getBillingPlantsMonth(org?.id ?? "", monthKey);
            setDataDetails(data);
        }
    }
}

const useBillingApi = () => {
    const f = useFetch()
    return {
        getBillingPlants: async (organizationId: string): Promise<BillingType> => {
            const url = "/api/organization/" + organizationId + "/billing";
            let e: RestItemContainer<BillingType> = await f.get(url);

            e?.item?.data?.forEach(b => {

                // ispremium_days
                const dates_premium = Object.keys(b)
                    .filter(key => key.startsWith("ispremium_"))
                    .filter(key => ((b as any)[key]) > 0)
                    .map(key => parseInt(key.substring(10, 18)));
                b.premium_days = dates_premium;
                Object.keys(b).filter(key => key.startsWith("ispremium_")).forEach(f => {
                    delete (b as any)[f]
                });


                const dates_offers = Object.keys(b)
                    .filter(key => key.startsWith("offer_"))
                    .filter(key => ((b as any)[key]) > 0)
                    .map(key => {
                        return {
                            datekey: parseInt(key.substring(6, 14)),
                            offerId: key?.substring(15, 51),
                            key: key
                        };
                    });

                let change: { [x: string]: number[] } = {};
                dates_offers.forEach(m => {
                    change[m.offerId] = [...(change[m.offerId] ?? []), m.datekey];
                });
                b.offer_days = change;
                dates_offers.forEach(m => delete (b as any)[m.key]);

            });

            console.log("e.item", e.item);
            return e.item;
        },
        getBillingPlantsMonth: async (organizationId: string, monthKey: number): Promise<string[]> => {
            const url = "/api/organization/" + organizationId + "/billing/" + monthKey;
            const e: RestListContainer<string> = await f.get(url);
            return e.items;
        }

    }
}

type BillingType = {
    plants: BillingMonthPlants[]
    data: BillingMonth[]
}

export type BillingMonthPlants = {
    id: string
    monthkey: number
    count: number
    organizationid: string
    sys_datemodified_utc_epoch: number
}

export type BillingMonth = {
    id: string
    // ispremium_YYYYMMDD: 1 | 0
    premium_days: number[]
    offer_days: { [x: string]: number[] }
    label: "organization_billing"
    monthkey: number
    organizationid: string
    sys_datecreated_utc_epoch: number
    sys_datemodified_utc_epoch: number
}

export type BillingMonthDetails = {
    [x: string]: string
}